import '../assets/NcActionSeparator-Ct2RnclR.css';
import { n as normalizeComponent } from "../chunks/_plugin-vue2_normalizer-DU4iP6Vu.mjs";
const _sfc_main = {
  name: "NcActionSeparator"
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("li", { staticClass: "action action-separator action--disabled", attrs: { "role": "separator" } });
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "3e2324b7"
);
const NcActionSeparator = __component__.exports;
export {
  NcActionSeparator as default
};
//# sourceMappingURL=NcActionSeparator.mjs.map
